/** 与后端 URL 上的 state 对齐（值就是后端给的字符串） */
export enum TiktokShopAuthState {
  Ok = "ok",
  Error = "error",
}

export const TIKTOK_SHOP_AUTH_RESPONSE_KEY = "tiktok-shop-auth-response";

/** 内部错误码：覆盖所有原本会触发 message.error 的位置 + 成功点 */
export enum TiktokShopAuthCode {
  Ok = "ok",
  GetAuthUrlFailed = "get_auth_url_failed",
  OpenWindowFailed = "open_window_failed",
  UserClosed = "user_closed",
  BackendError = "backend_error",
  UnknownState = "unknown_state",
}

/** 判别联合：state=Ok 时 code 一定是 Ok；state=Error 时 code 是其它 */
export type TiktokShopAuthResult =
  | { state: TiktokShopAuthState.Ok; code: TiktokShopAuthCode.Ok; msg?: string }
  | { state: TiktokShopAuthState.Error; code: Exclude<TiktokShopAuthCode, TiktokShopAuthCode.Ok>; msg?: string };

export const TIKTOK_SHOP_AUTH_RESULT = "TIKTOK_SHOP_AUTH_RESULT" as const;

/**
 * BroadcastChannel 名称：弹窗回调页用它向父窗口广播授权结果。
 * 走 BroadcastChannel 而不是 postMessage(opener, ...) 是为了规避 COOP 隔离 ——
 * 弹窗在 TikTok / 后端 callback 链路中可能被 BCG swap 切断 window.opener，
 * 而 BroadcastChannel 同源内总是连通。
 */
export const TIKTOK_SHOP_AUTH_BROADCAST_CHANNEL = "tiktok-shop-auth";

export type TiktokShopAuthResultMessage = {
  type: typeof TIKTOK_SHOP_AUTH_RESULT;
  state: TiktokShopAuthState | null;
  msg?: string;
};
